import { useState } from "react";
import { LogIn, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";

const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_sales-tracker-1336/artifacts/xrne8mgy_versao_branca_03.webp";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) return;
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Bem-vinda de volta");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Falha ao entrar");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-background grid lg:grid-cols-2">
      {/* Lado marca */}
      <div className="hidden lg:flex bg-primary text-primary-foreground p-12 flex-col justify-between relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.10] pointer-events-none"
          style={{ backgroundImage:
            "radial-gradient(circle at 20% 30%, #fff 0, transparent 40%), radial-gradient(circle at 80% 70%, #fff 0, transparent 40%)" }}
        />
        <div className="relative">
          <img src={LOGO_URL} alt="FLUA" className="h-10 w-auto" />
        </div>
        <div className="relative">
          <h2 className="font-heading text-4xl font-bold tracking-tight">Controle comercial<br /> de ponta a ponta</h2>
          <p className="mt-3 text-white/80 max-w-sm">
            Metas, funil semanal, síndicos, clientes e comissões — tudo em um único painel para a equipe FLUA.
          </p>
        </div>
        <div className="relative text-xs text-white/60">© FLUA · Painel Comercial</div>
      </div>

      {/* Lado form */}
      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="login-form">
          <div>
            <div className="text-[10px] uppercase tracking-[0.24em] text-muted-foreground mb-2">Acessar painel</div>
            <h1 className="font-heading text-3xl font-bold tracking-tight">Bem-vinda de volta</h1>
            <p className="text-sm text-muted-foreground mt-1">Entre com seu e-mail e senha para continuar.</p>
          </div>
          <div className="space-y-1.5">
            <Label>E-mail</Label>
            <Input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="voce@flua.com"
              data-testid="login-email"
              required
            />
          </div>
          <div className="space-y-1.5">
            <Label>Senha</Label>
            <Input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              data-testid="login-password"
              required
            />
          </div>
          <Button type="submit" className="w-full" disabled={busy} data-testid="login-submit">
            {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <LogIn className="w-4 h-4 mr-2" />}
            Entrar
          </Button>
          <div className="text-xs text-muted-foreground text-center pt-2">
            Sem acesso? Fale com o(a) administrador(a) da FLUA para receber suas credenciais.
          </div>
        </form>
      </div>
    </div>
  );
}
